module.exports = (__webpack_require__(8))(17);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/collections/Collection.js from dll-reference girder_lib
// module id = 962
// module chunks = 0